module.exports = __webpack_public_path__ + "img/editIcon.1021bb13.svg";